// SPDX-License-Identifier: AGPL-3.0-or-later

import {http} from '@app/features/platform/transport/RestTransport';

export const CYCI_PROFILE_ENDPOINT = '/users/@me/cyci-profile';

export const CYCI_PROFILE_THEMES = [
	'default',
	'glass',
	'neon',
	'minimal',
	'obsidian',
	'void',
	'midnight',
	'monochrome',
	'eclipse',
] as const;
export const CYCI_PROFILE_EFFECTS = ['none', 'glow', 'stars', 'embers'] as const;
export const CYCI_PROFILE_AVATAR_FRAMES = ['none', 'ring', 'neon', 'glass'] as const;
export const CYCI_PROFILE_NAME_STYLES = ['default', 'accent', 'glow', 'gradient', 'muted', 'monochrome'] as const;

export type CyciProfileTheme = (typeof CYCI_PROFILE_THEMES)[number];
export type CyciProfileEffect = (typeof CYCI_PROFILE_EFFECTS)[number];
export type CyciProfileAvatarFrame = (typeof CYCI_PROFILE_AVATAR_FRAMES)[number];
export type CyciProfileNameStyle = (typeof CYCI_PROFILE_NAME_STYLES)[number];

export interface CyciProfile {
	theme: CyciProfileTheme;
	secondary_color: number | null;
	effect: CyciProfileEffect;
	avatar_frame: CyciProfileAvatarFrame;
	name_style: CyciProfileNameStyle;
	featured_title: string | null;
}

export type CyciProfilePatch = Partial<CyciProfile>;

export async function fetchCurrent(): Promise<CyciProfile> {
	const response = await http.get<CyciProfile>(CYCI_PROFILE_ENDPOINT);
	return response.body;
}

export async function updateCurrent(patch: CyciProfilePatch): Promise<CyciProfile> {
	const response = await http.patch<CyciProfile>(CYCI_PROFILE_ENDPOINT, {
		body: patch,
	});
	return response.body;
}

export const CYCI_PROFILE_BATCH_ENDPOINT = '/users/cyci-profiles/batch';

export async function fetchBatch(userIds: Array<string>): Promise<Record<string, CyciProfile>> {
	const response = await http.post<Record<string, CyciProfile>>(
		CYCI_PROFILE_BATCH_ENDPOINT,
		{
			body: {
				user_ids: userIds,
			},
		},
	);

	return response.body;
}
